import { AllowedIcons } from '@thyme/nashville/src/types/icons'
import { ToastPosition } from '@thyme/nashville/src/types/toasts'
import { createProp } from '@thyme/nashville/src/utils/designTokens'
import type { ToastMessageOptions } from 'primevue/toast'
import type { ExtractPropTypes } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

export const T_TOAST_PROPS = {
  /** viewport corner the whole stack is anchored to */
  position: createProp(ToastPosition, ToastPosition.TOP_RIGHT),
  group: {
    type: String,
    default: undefined,
  },
  headerIcon: createProp(AllowedIcons, AllowedIcons.bell),
  actionIcon: createProp(AllowedIcons, AllowedIcons.arrowTopRightOnSquare),
  closeLabel: {
    type: String,
    default: 'Close notification',
  },
} as const

export type TToastProps = ExtractPropTypes<typeof T_TOAST_PROPS>

/**
 * Pass `useTToast().add()` rather than `useToast().add()`, which is typed
 * against PrimeVue's `ToastMessageOptions` and rejects our additional fields below.
 */
export type TToastMessage = ToastMessageOptions & {
  /**
   * PrimeVue autogenerates id if none passed; only need to pass if need to track toasts
   * (i.e. to prevent re-emitting of manually dismissed toasts on new query)
   */
  id?: string | number
  headerTitle?: string
  headerIcon?: (typeof AllowedIcons)[keyof typeof AllowedIcons] | null
  /** rendering the action button is opt-in: no label, no button */
  actionLabel?: string
  actionIcon?: (typeof AllowedIcons)[keyof typeof AllowedIcons] | null
  actionTo?: RouteLocationRaw
}
